import { ResponsiveTypography, ResponsiveTypographyVariant } from '@se-admin/falcon';
import { History } from 'history';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { IPageName } from '../../common/types/apiSchema';
import { getPaths } from '../../constants/paths/paths';
import { SaleCardVariant } from '../SaleCard/SaleCard.interfaces';
import { ImageLabelContainer } from '../SaleCard/SaleCard.styles';
import { BookingCardButton, BookingCardDetails, BookingCardImage } from './BookingCard.components';
import { IBookingCardProps } from './BookingCard.interfaces';
import { BookingCardWrapper, ContentContainer } from './BookingCard.styles';

const BookingCard: React.FunctionComponent<IBookingCardProps> = ({ booking }) => {
  const location: string = `${booking.saleLocation.city.name}, ${booking.saleLocation.country.name}`;
  const history: History = useHistory();
  const url: string = getPaths(IPageName.bookingsPage)[0];

  const handleClick: () => void = () => {
    if (booking.links.viewExternalBookingDetails) {
      window.location.assign(booking.links.viewExternalBookingDetails);
    } else {
      history.push(`${url}/${booking.id}/details`);
    }
  };

  return (
    <BookingCardWrapper data-testid="BookingCard" onClick={handleClick}>
      <ImageLabelContainer variant={SaleCardVariant.normal}>
        <BookingCardImage leadImage={booking.leadImage} />
      </ImageLabelContainer>
      <ContentContainer>
        <ResponsiveTypography variant={ResponsiveTypographyVariant.micro}>
          {location}
        </ResponsiveTypography>
        <ResponsiveTypography variant={ResponsiveTypographyVariant.t5Serif}>
          {booking.title}
        </ResponsiveTypography>
        <BookingCardDetails booking={booking} />
        <BookingCardButton booking={booking} />
      </ContentContainer>
    </BookingCardWrapper>
  );
};

export default BookingCard;
